module.exports = __webpack_public_path__ + "Pe-icon-7-stroke.01798bc13e33afc36a52.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/newtheme/fonts/Pe-icon-7-stroke.ttf?d7yf1v
// module id = 863
// module chunks = 2